"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAdultContentFilterComponent = void 0;
const _ = require("underscore");
const shared_1 = require("../../shared");
const features_services_1 = require("../../../mma/features/services/features.services");
const constants_1 = require("../../shared/constants");
class CSAdultContentFilterComponent {
    constructor(accountDetailService, helperService, featuresService, rolesService) {
        this.accountDetailService = accountDetailService;
        this.helperService = helperService;
        this.featuresService = featuresService;
        this.rolesService = rolesService;
        this.isDisabled = true;
        this.hasACFValues = [];
        this.initialACFValues = [];
        this.showDetails = true;
        this.subIdsAddArr = [];
        this.subIdsRemoveArr = [];
        this.acfSortNumber = '1-10';
        this.currentIndex = 0;
        this.sortFilterArray = ['1-10', '20 lines', '50 lines', '100 lines'];
        this.pager = {};
        this.roles = constants_1.UserRole;
    }
    ngOnInit() {
        if (this.isPrepaidAcc) {
            this.productId = 'prod29060088';
        }
        else {
            this.productId = 'prod29060087';
        }
        this.paginationSize = -1;
        this.getAllFeatures();
        this.onSelectSort(this.acfSortNumber);
    }
    ngOnChanges() {
        var _a, _b, _c;
        if (this.subList) {
            this.subList = (_a = this.subList) === null || _a === void 0 ? void 0 : _a.filter(function (subscription) {
                var _a;
                if (((_a = subscription === null || subscription === void 0 ? void 0 : subscription.plan) === null || _a === void 0 ? void 0 : _a.planName) !== 'WEARABLE_DPPONLY') {
                    return subscription;
                }
            });
        }
        if (this.isPrimary || (this.businessAccount && this.showRoles([this.roles.ACCOUNT_PRIMARY, this.roles.IT_SUPPORT]))) {
            this.featureList = _.clone(this.subList);
            this.showSearchbox = ((_b = this.featureList) === null || _b === void 0 ? void 0 : _b.length) > 10;
        }
        else {
            this.featureList = _.where(this.subList, { 'mobileNumber': this.mobileNumber });
        }
        this.showCard = ((_c = this.featureList) === null || _c === void 0 ? void 0 : _c.length) > 0;
    }
    getAllFeatures() {
        this.loader = true;
        this.featuresService.getFeatures()
            .subscribe((res) => {
            this.areACFToggled = false;
            const features = this.filterOutWearableDPPPlan(res.featureDetail);
            this.allFeatures = features;
            this.initialState = res.featureDetail;
            this.featureList = _.sortBy(this.allFeatures, 'mobileNumber');
            this.updateAllACFToggles(this.allFeatures);
            this.initialACFValues = this.initialState.map((fd) => fd.hasACF);
            this.hasACFValues = this.allFeatures.map((fd) => fd.hasACF);
            this.updateACFValues();
            this.acfSortNumber = '1-10';
            this.onSelectSort(this.acfSortNumber);
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    filterOutWearableDPPPlan(featureList) {
        const features = featureList === null || featureList === void 0 ? void 0 : featureList.filter(function (feature) {
            if ((feature === null || feature === void 0 ? void 0 : feature.planSvcName) !== 'WEARABLE_DPPONLY') {
                return feature;
            }
        });
        return features;
    }
    submitACFChanges() {
        this.loader = true;
        const content = {
            'subIdsAdded': this.subIdsAdd,
            'subIdsRemoved': this.subIdsRemove,
            'featureProductId': this.productId
        };
        this.accountDetailService.addRemoveFeatures(content).subscribe(() => {
            this.loader = false;
            this.isDisabled = true;
            if (this.businessAccount) {
                window.location.href = '/my_account/b2b/shop/';
            }
            else {
                window.location.href = '/buy/';
            }
        }, (err) => {
            this.isDisabled = false;
            this.error = err;
        });
    }
    showRoles(roles) {
        return this.rolesService.getRolesPermission(roles);
    }
    toggleAllACFButton(featureList) {
        this.allACF = !this.allACF;
        this.areACFToggled = true;
        featureList.forEach((toggle) => {
            toggle.hasACF = this.allACF;
            this.updateHasACFValues(toggle.subscriptionId, toggle.hasACF);
            this.addRemoveSubId(toggle);
        });
        this.updateACFValues();
    }
    toggleACFButton(feature) {
        feature.hasACF = !feature.hasACF;
        this.addRemoveSubId(feature);
        this.updateHasACFValues(feature.subscriptionId, feature.hasACF);
        this.updateACFValues();
    }
    updateAllACFToggles(featureList) {
        let initialACFActive = true;
        featureList.forEach(function (feature) {
            if (feature.hasACF === false) {
                initialACFActive = false;
            }
        });
        this.allACF = initialACFActive;
    }
    updateACFValues() {
        for (let i = 0; i <= this.initialACFValues.length; i++) {
            if (this.initialACFValues[i] !== this.hasACFValues[i]) {
                this.isDisabled = false;
                break;
            }
            else {
                this.isDisabled = true;
            }
        }
    }
    updateHasACFValues(subscriptionId, hasACF) {
        const index = this.allFeatures.findIndex((fd) => fd.subscriptionId === subscriptionId);
        if (index !== -1) {
            this.allFeatures[index].hasACF = hasACF;
            this.hasACFValues[index] = hasACF;
        }
    }
    addRemoveSubId(feature) {
        if (feature.hasACF !== this.checkInitialState(feature)) {
            if (feature.hasACF === true) {
                if (!this.subIdsAddArr.includes(feature.subscriptionId)) {
                    this.subIdsAddArr.push(feature.subscriptionId);
                }
                if (this.subIdsRemoveArr.includes(feature.subscriptionId)) {
                    this.subIdsRemoveArr = this.subIdsRemoveArr.filter((x) => x !== feature.subscriptionId);
                }
            }
            else {
                if (!this.subIdsRemoveArr.includes(feature.subscriptionId)) {
                    this.subIdsRemoveArr.push(feature.subscriptionId);
                }
                if (this.subIdsAddArr.includes(feature.subscriptionId)) {
                    this.subIdsAddArr = this.subIdsAddArr.filter((x) => x !== feature.subscriptionId);
                }
            }
            this.subIdsRemove = this.subIdsRemoveArr.join(',');
            this.subIdsAdd = this.subIdsAddArr.join(',');
        }
    }
    checkInitialState(feature) {
        if (feature.hasACF === this.initialState.hasACF) {
            this.subIdsAddArr = this.subIdsAddArr.filter((x) => x !== feature.subscriptionId);
            this.subIdsRemoveArr = this.subIdsRemoveArr.filter((x) => x !== feature.subscriptionId);
        }
        return this.initialState.hasACF;
    }
    setPage(page, pageSize) {
        if (this.pager.totalPages !== 0) {
            if (page < 1 || page > this.pager.totalPages) {
                return;
            }
        }
        if (pageSize === '1-10') {
            pageSize = 10;
        }
        else if (pageSize === '20 lines') {
            pageSize = 20;
        }
        else if (pageSize === '50 lines') {
            pageSize = 50;
        }
        else if (pageSize === '100 lines') {
            pageSize = 100;
        }
        // get pager object from service
        if (this.featureList && page !== undefined) {
            this.pager = this.helperService.getPager(this.featureList.length, page, pageSize);
            this.startIndex = this.pager.startIndex;
            this.endIndex = this.pager.endIndex + 1;
        }
    }
    onSelectSort(selectNumber) {
        this.setPage(1, selectNumber);
        if (selectNumber === '1-10') {
            this.sortNumber = 10;
        }
        else if (selectNumber === '20 lines') {
            this.sortNumber = 20;
        }
        else if (selectNumber === '50 lines') {
            this.sortNumber = 50;
        }
        else if (selectNumber === '100 lines') {
            this.sortNumber = 100;
        }
        this.setPage(this.pager.currentPage, this.sortNumber);
    }
    onInputSearchChange(searchText) {
        var _a;
        const searchPipe = new shared_1.SearchFilterPipe();
        const searchTextWithoutDashes = this.sanitizePhoneNumber(searchText);
        this.featureList = searchPipe.transform(this.subList, { 'mobileNumber': searchTextWithoutDashes, 'subscriberBusinessName': searchText, 'esnMeid': searchText, 'modelNumber': searchText, 'isSearchData': true }, false);
        this.acfSortNumber = '1-10';
        this.onSelectSort(this.acfSortNumber);
        if (((_a = this.featureList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const index = this.featureList.findIndex((sub) => sub.subscriptionId === this.selectedSubscriptionId);
            this.currentIndex = index;
            this.searchQuery = searchText;
        }
    }
    sanitizePhoneNumber(phoneNumber) {
        // Remove dashes from the phone number
        return phoneNumber.replace(/-/g, '');
    }
}
exports.CSAdultContentFilterComponent = CSAdultContentFilterComponent;
//# sourceMappingURL=adultcontentfiltering.component.js.map